import axios from "@/axios";
import dc from "@/component/utils/DataChk";

export default {
    // 이미지 url 추출
    extractImageSources(content) {
        const imgRegex = /!\[[^\]]*\]\(([^)]+)\)/g;
        const matches = content.match(imgRegex);

        if (!matches) return [];

        return matches
            .map((match) => {
                const srcMatch = match.match(/\(([^)]+)\)/);
                const src = srcMatch ? srcMatch[1].trim() : null;
                if (
                    src &&
                    !src.includes("/file/eimg-download/editor/images") && // imageDirectory
                    !src.startsWith(process.env.VUE_APP_REDIRECT_PREFIX) // redirectPrefix
                ) {
                    return src;
                }
                return null;
            })
            .filter(Boolean); // null 제거
    },
    async saveEditorUrlImages(saveUrlList, system) {
        try {
            const changeUrlList = await this.saveEditorUrlImagesSequentially(saveUrlList, system);

            if (!changeUrlList || changeUrlList.length !== saveUrlList.length) {
                throw new Error("이미지 저장 실패");
            }

            return changeUrlList;
        } catch (error) {
            console.error(error);
            return;
        }
    },
    async saveEditorUrlImagesSequentially(urls, type) {
        let changeUrlList = [];
        for (let i = 0; i < urls.length; i++) {
            try {
                let changeUrl = await this.saveEditorUrlImage(urls[i], type);
                if (changeUrl == null || changeUrl === "") {
                    alert(
                        "아래 URL에서 이미지 저장을 실패하였습니다.\n이미지 파일로 등록하시길 권장드립니다.\n[" +
                            urls[i] +
                            "]"
                    );
                    return null;
                }
                // 성공 시 결과 list에 push
                changeUrlList.push(changeUrl);
            } catch (error) {
                if (error == null) {
                    // 에러 메세지가 없는 경우
                    alert("아래 URL에서 이미지 저장을 실패하였습니다.\n[" + urls[i] + "]");
                } else {
                    // 에러 메세지가 존재하는 경우
                    alert(error);
                }
                return null;
            }
        }
        return changeUrlList;
    },
    // URL 이미지 저장
    async saveEditorUrlImage(img_url, type) {
        // 이미지 저장 api 호출
        try {
            const res = await axios.post(`/${type}/pr/file/editor-url/add`, { url: img_url });
            if (res.data.resType === "RES_OK") {
                return res.data.resMsg;
            }
            return null;
        } catch (error) {
            console.error(error);
        }
    },
    async handleEditorImages(target, fields, type) {
        try {
            const tempList = this.extractImagesFromFields(target, fields);
            const saveUrlList = [...new Set(tempList)];

            if (!dc.nullChk(saveUrlList)) return true;

            const changeUrlList = await this.saveEditorUrlImages(saveUrlList, type);

            this.replaceEditorImageUrls(target, fields, saveUrlList, changeUrlList);
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    },
    extractImagesFromFields(targetData, fields) {
        const result = [];

        fields.forEach((field) => {
            result.push(...this.extractImageSources(targetData[field] || ""));
        });

        return result;
    },
    replaceEditorImageUrls(data, fields, oldUrls, newUrls) {
        fields.forEach((field) => {
            oldUrls.forEach((oldUrl, i) => {
                data[field] = data[field]?.replaceAll(oldUrl, newUrls[i]);
            });
        });
    },
};
